// Conversation persistence for AI Co-pilot mode.
// BookingFlow saves the conversation here when transitioning to results.
// SupplierResults loads it to continue the conversation seamlessly.

import { ConversationTurn } from './agenticAgent'

const STORAGE_KEY = 'pair2.copilot.conversation'

export function saveConversation(turns: ConversationTurn[]) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(turns))
  } catch {
    // ignore
  }
}

export function loadConversation(): ConversationTurn[] {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return []
    return JSON.parse(raw) as ConversationTurn[]
  } catch {
    return []
  }
}

export function clearConversation() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    // ignore
  }
}
